"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuarterOrdinal = exports.getQuarterNumeric = void 0;
var month_1 = require("./month");
/**
 * Returns a numerical representation of the quarter: 1, 2, 3, 4
 * @hidden
 */
var getQuarterNumeric = function (params) {
    var month = month_1.getMonthNumeric(params);
    return Math.ceil(month / 3);
};
exports.getQuarterNumeric = getQuarterNumeric;
/**
 * Returns an ordinal string representation of the quarter: 1st, 2nd, 3rd, 4th
 * @hidden
 */
var getQuarterOrdinal = function (params) {
    var quarter = exports.getQuarterNumeric(params);
    return params.ordinalStringFormatter(quarter);
};
exports.getQuarterOrdinal = getQuarterOrdinal;
//# sourceMappingURL=quarter.js.map